"use strict";

import { PRO_CLIENTS, PLUS_CLIENTS, BASIC_CLIENTS } from "@/config/ClientApps";

const UserClient = {
	hasProOrPlusFeatures: (clientApps) => {
		const proAndPlusClients = [...PRO_CLIENTS, ...PLUS_CLIENTS];
		return clientApps.some((item) => proAndPlusClients.includes(item));
	},

	hasProFeatures: (clientApps) =>
		clientApps.some((item) => PRO_CLIENTS.includes(item)),

	hasPlusFeatures: (clientApps) =>
		clientApps.some((item) => PLUS_CLIENTS.includes(item)),

	hasBasicFeatures: (clientApps) =>
		clientApps.some((item) => BASIC_CLIENTS.includes(item)),
};

export default UserClient;
